import { TextFieldProps, TextField, OutlinedInputProps, InputBase } from "@mui/material"
import {alpha, createTheme, styled} from "@mui/material/styles"

export const appTheme = createTheme({
    palette:{
        primary:{
            main: '#a44a9b'
        },
        success:{
          main:'#0faa2e'
        },
        warning:{
          main:'#f9b623'
        },
        error:{
          main:'#ff0303'
        }

    },
    typography: {
        fontFamily: [
          'Inter',
          'sans-serif',
        ].join(','),
      }
})
export const RedditTextField = styled((props: TextFieldProps) => (
  <TextField size="small"
      InputProps={{ disableUnderline: true } as Partial<OutlinedInputProps>}
      {...props}
  />
))(({ theme }) => ({
  '& .MuiFilledInput-root': {
      overflow: 'hidden',
      boxShadow:'0px 2px 5px rgb(0 0 0 / 11%) ',
      borderRadius: 8,
      border: '1px solid #d5d6d8',
      backgroundColor: '#ffffff',
      transition: theme.transitions.create([
          'border-color',
          'background-color',
          'box-shadow',
      ]),
      '& .MuiFilledInput-input':{
        paddingTop:'12px !important'
      },

      '&:hover': {
          backgroundColor: 'transparent',
          borderBottom:'none'
      },
      '&.Mui-focused': {
          backgroundColor: 'transparent',
          boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
          borderColor: theme.palette.primary.main,
      },
      '&:before':{
          borderBottom:'none',
          paddingTop:'12px !important'
      }
  },
}));

export const BootstrapInput = styled(InputBase)(({ theme }) => ({
    '& .MuiInputBase-input': {
      position: 'relative',
      backgroundColor: theme.palette.mode === 'light' ? '#fcfcfb' : '#2b2b2b',
      fontSize: 16,
      width: '100%',
      padding: '10px 12px',
      boxShadow:'0px 2px 5px rgb(0 0 0 / 11%) ',
      borderRadius: 8,
      border: '1px solid #d5d6d8',
      transition: theme.transitions.create([
        'border-color',
        'background-color',
        'box-shadow',
      ]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        'Inter','sans-serif',
      ].join(','),
      '&:focus': {
        boxShadow: `${alpha(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
        borderColor: theme.palette.primary.main,
      },
    },
    '& .MuiTextField-root':{
        width:'100%'
    },
  }));
